/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import PrimaryButton from 'components/form/buttons/primaryButton';
import TicketFilterPopup from '../filterForm';
import PaginationApp from 'components/pagination';

import * as S from './styles';
import * as T from 'common/types';
import { durationTypeEnum } from 'common/enums';

interface IProps {
  data: { data: []; count: number };
  loading: boolean;
}

export default function ErpTable({ data, loading }: IProps) {
  const { erpRequestAction } = useActions();

  const [meta, setMeta] = useState({
    page: 1,
    size: 10,
    keyword: '',
    type: '',
    orderBy: 'createdAt',
    orderType: 'desc' // desc | asc
  });

  const fetchData = () => {
    erpRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };

  const handleChangePageSize = (size: number) => {
    setMeta({ ...meta, size });
  };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox
            onChange={(e) => setMeta({ ...meta, keyword: e })}
            placeholder="Search"
            inputStyle={{ height: 36, borderRadius: 10, fontSize: 12 }}
            style={{ width: 500 }}
            value={meta.keyword}
          />
          <TicketFilterPopup setFilter={setMeta} filter={meta} />
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, title: 'Requested By', dir: 'left' },
            { id: 2, title: 'Awaiting for', dir: 'left' },
            { id: 3, title: 'Status', dir: 'left' },
            { id: 4, title: 'Request Type', dir: 'left' },
            { id: 10, title: 'Last Change By User', dir: 'left' },
            { id: 5, title: 'Start', dir: 'left' },
            { id: 6, title: 'End', dir: 'left' },
            { id: 7, title: 'Duration', dir: 'left' },
            { id: 8, title: 'Requested At', dir: 'left' },
            // { id: 9, title: 'attachments', dir: 'left' },
            { id: 11, title: '' }
          ]}
          loading={loading}
          data={data.data}
          altanfeethiFields={{
            user: (item: T.Pages.ErpResponse) => (
              <S.User className="text-left">
                {/* <img src={item.createdByUser?.profilePicture} alt={item.createdByUser?.displayName} /> */}
                {item.createdByUser?.displayName || '-'}
              </S.User>
            ),
            awaiting: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left">
                {item?.awaitingForManager
                  ? 'Line Manager: ' + item?.awaitingForUser?.displayName
                  : item?.awaitingForRole
                    ? 'Role: ' + item?.awaitingForRole
                    : '-'}
              </S.Div>
            ),
            status: (item: T.Pages.ErpResponse) => <S.Div className="text-left">{item?.status.value || '-'}</S.Div>,
            absenceTypeName: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left">{item?.absenceTypeName || '-'}</S.Div>
            ),
            lastChangeByUser: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left captal">{item?.lastChangeByUser?.displayName || 'Erp System'}</S.Div>
            ),
            start: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left">
                {item?.startDate} {item?.startTime ? item?.startTime : ''}{' '}
                {item?.startDateDurationIsFull || '-'
                  ? '(Full)'
                  : item?.startDateDurationIsFull === false
                    ? '(Half)'
                    : ''}
              </S.Div>
            ),
            end: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left">
                {item?.endDate} {item?.endTime ? item?.endTime : ''}{' '}
                {item?.endDateDurationIsFull ? '(Full)' : item?.endDateDurationIsFull === false ? '(Half)' : ''}
              </S.Div>
            ),

            duration: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left captal">
                {item?.duration +
                  ' ' +
                  // @ts-ignore
                  durationTypeEnum[item?.durationType] || '-'}
              </S.Div>
            ),
            createdAt: (item: T.Pages.ErpResponse) => (
              <S.Div className="text-left">{new Date(item?.createdAt).toLocaleString() || '-'}</S.Div>
            ),

            // status: (item: T.Pages.ErpResponse) => (
            //   <S.Div className="text-left">
            //     <S.Status className={item.status}>
            //       <S.Span></S.Span>
            //       {item.status}
            //     </S.Status>
            //   </S.Div>
            // ),
            edit: (item: T.Pages.ErpResponse) => (
              <PrimaryButton
                style={{
                  height: 28,
                  fontSize: 12,
                  background: '#8A93AC',
                  color: 'var(--white)',
                  width: 94,
                  margin: 'auto',
                  borderRadius: 8
                }}
                link={`/panel/erp/${item?.id}`}
              >
                Show
              </PrimaryButton>
            )
          }}
        />
      </PanelBoxLayout>

      {data.count ? (
        <PaginationApp
          page={meta.page}
          count={data.count}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.count}
          pageSize={meta.size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )}
    </S.Content>
  );
}
